import router from "@/router";
import UM from "@/api/user-management";
import TM from "@/api/ticket-management";
// import Cookie from 'js-cookie'
import store from "@/store";

import { parseJwt } from "@/shared/utils";

const pdfUrl = process.env.VUE_APP_REFUND_PDF;

const getDefaultState = () => {
  return {
    account: "", // 登入的手機
    id: "",
    access_token: "",
    refresh_token: "",
    access_token_expires_in: 0,
    verifyEmail: false,
    pdfUrl: pdfUrl,
    recaptchaToken: null,
    recaptchaStatus: ""
  };
};

//init state
const state = getDefaultState();

const mutations = {
  SET_USER: (
    state,
    {
      account = "",
      id = "",
      access_token = "",
      refresh_token = "",
      access_token_expires_in = 0,
      verifyEmail = false
    }
  ) => {
    state.account = account;
    state.id = id;
    state.access_token = access_token;
    state.refresh_token = refresh_token;
    state.access_token_expires_in = access_token_expires_in;
    state.verifyEmail = verifyEmail;
  },
  REFRESH_TOKEN: (
    state,
    { access_token = "", access_token_expires_in = 0, refresh_token = "" }
  ) => {
    state.access_token = access_token;
    state.access_token_expires_in = access_token_expires_in;
    state.refresh_token = refresh_token;
  },
  SET_TOKEN: (state, access_token) => {
    state.access_token = access_token;
  },
  SET_VERIFY: (state, verifyStatus) => {
    state.verifyEmail = verifyStatus;
  },
  SET_RECAPTCHA_TOKEN: (state, token) => {
    state.recaptchaToken = token;
  },
  SET_RECAPTCHA_STATUS: (state, status) => {
    state.recaptchaStatus = status;
  },
  RESET: state => {
    // console.log("[vuex/user] RESET user state");
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  // user login
  login({ commit }, userData) {
    const JwtDecode = parseJwt(userData?.access_token || "");
    userData.account = JwtDecode?.maskedMobile || account;
    Cookies.set("user", JSON.stringify(userData), { expires: 90 });
    let currTime = new Date();
    let expiredTime = currTime.setSeconds(
      currTime.getSeconds() + userData.access_token_expires_in
    );
    Cookies.set("expiredTime", JSON.stringify(expiredTime), { expires: 90 });

    commit("SET_USER", userData);
    window.clarity("identify", userData.id);
    let toPath = Cookies.get("toPath");
    if (toPath) router.push({ path: toPath });
    return true;
  },
  // user logout
  logout({ commit, dispatch, rootState }) {
    Cookies.remove("user");
    Cookies.remove("expiredTime");
    Cookies.remove("toPath");
    commit("RESET", "");
    if (rootState.settings.drawer.show)
      dispatch(
        "DrawerToggle",
        {},
        {
          root: true
        }
      );
  },

  logoutToIndex({ commit, dispatch, rootState }) {
    Cookies.remove("user");
    Cookies.remove("expiredTime");
    Cookies.remove("toPath");
    commit("RESET", "");
    if (rootState.settings.drawer.show)
      dispatch(
        "DrawerToggle",
        {},
        {
          root: true
        }
      );

    window.location.href = "/";
  },

  // get user info
  async getInfo({ commit, state }) {
    const isProd = process.env.VUE_APP_PROD === "true";
    const userData = JSON.parse(Cookies.get("user") || null);
    const t = new Date().valueOf();
    const log = JSON.parse(window.localStorage.getItem("tp"))
      ? JSON.parse(window.localStorage.getItem("tp"))
      : 0;
    const dist = 60000;

    if (userData) {
      commit("SET_USER", userData);
      if (!(!log || t - log >= dist)) return;
      const { data: tokenData } = await UM.verifyToken(userData.access_token);
      window.localStorage.setItem("tp", new Date().valueOf());

      if (tokenData.errCode === "00" && tokenData.valid) {
        if (!userData.account) {
          const { data } = await UM.getUserInfo();
          if (data.errCode === "00") {
            userData.id = data.userInfo.id;
            userData.account = data.userInfo.mobile;
            Cookies.set("user", userData);
          }
        }

        if (userData !== state) {
          commit("SET_USER", userData);
        }
      } else {
        Cookies.remove("toPath");
        store.dispatch("user/logout");
      }
    } else {
      Cookies.remove("user");
      commit("RESET", "");
    }
  },

  // refresh token
  refreshToken({ commit, state }, userData) {
    const user = JSON.parse(Cookies.get("user"));
    const JwtDecode = parseJwt(userData?.access_token || "");
    userData.account = JwtDecode?.maskedMobile || "";
    userData.id = JwtDecode?.id || "";

    const refreshUser = { ...user, ...userData };
    let currTime = new Date();
    let expiredTime = currTime.setSeconds(
      currTime.getSeconds() + userData.access_token_expires_in
    );
    Cookies.set("expiredTime", expiredTime, { expires: 90 });

    commit("REFRESH_TOKEN", refreshUser);
    // console.info(`[TOKEN] Refreshed`);
    Cookies.set("user", JSON.stringify(refreshUser), { expires: 90 });
    return true;
  },

  setVerifyStatus({ commit }, verifyStatus) {
    commit("SET_VERIFY", verifyStatus);
  },

  setRecaptchaToken({ commit }, token) {
    commit("SET_RECAPTCHA_TOKEN", token);
  },
  setRecaptchaStatus({ commit }, status) {
    commit("SET_RECAPTCHA_STATUS", status);
  }
};

const getters = {
  id: state => state.id,
  access_token: state => state.access_token,
  verifyEmail: state => state.verifyEmail,
  refresh_token: state => state.refresh_token,
  pdfUrl: state => state.pdfUrl,
  recaptchaToken: state => state.recaptchaToken,
  recaptchaStatus: state => state.recaptchaStatus
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
